var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-ssr',[_c('div',{staticClass:"background-path"},[_c('div',{staticClass:"path-1"}),_vm._v(" "),_c('div',{staticClass:"path-6"}),_vm._v(" "),_c('div',{staticClass:"path-wave"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }